import './headline.css'

import { Baukasten } from '../v7/ScrollytellingV7'
import { headlineLayer } from './headlines'

/**
 * Version 8 „Headlines“: der Baukasten aus Version 7, aber ohne lange
 * Captions unten links. Jede Station hat eine kurze, große Headline oben
 * links, die sich beim Scrollen Wort für Wort aufbaut.
 */
export default function ScrollytellingV8() {
  return (
    <Baukasten
      textMode='headline'
      textLayer={headlineLayer}
      centerY={0.58}
      className='hl-mode'
    />
  )
}
